// Enquiries client — /api/v1/platform/enquiries (website plan §6.3, §6.4).
//
// MODERATOR and above, enforced by the controller.

import { apiClient, apiClientPaginated } from '@/lib/api-client';
import type {
  Enquiry,
  EnquiryFilters,
  EnquirySummary,
  UpdateEnquiryInput,
} from '@/types/enquiry';

const BASE = '/platform/enquiries';

export const enquiriesService = {
  /** Newest first. Empty filters are left out of the query. */
  list(filters: EnquiryFilters, page: number, limit = 20) {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value) query.set(key, String(value));
    }
    query.set('page', String(page));
    query.set('limit', String(limit));
    return apiClientPaginated<Enquiry[]>(`${BASE}?${query.toString()}`);
  },

  summary() {
    return apiClient<EnquirySummary>(`${BASE}/summary`);
  },

  get(id: string) {
    return apiClient<Enquiry>(`${BASE}/${id}`);
  },

  update(id: string, input: UpdateEnquiryInput) {
    return apiClient<Enquiry>(`${BASE}/${id}`, { method: 'PATCH', body: input });
  },
};
